import { TipoItem, Udm } from "../../../isp.žapi.items/constantesApiItems";

/* const TipoItem = {
    PlanInternet: "planInt",
    ServiciosGen: "servGen",
    Articulo: "art",
};

const Udm = {
    Mensual: "mensual",
    Unidad: "unid",
};

const Moneda = {
    Soles: "sol",
    Dolares: "usd",
}; */

const EstadosItemLabel = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};


const TipoItemLabel = {};
// TipoItemLabel[TipoItem.PlanInternet] = "Plan.Int.";
TipoItemLabel[TipoItem.ServiciosGen] = "Serv. Gen.";
TipoItemLabel[TipoItem.Articulo] = "Articulo";
    
const UnidadItemLabel = {}
// UnidadItemLabel[Udm.Mensual] = "Mensual";
UnidadItemLabel[Udm.Unidad] = "Unid.";

export {TipoItemLabel, UnidadItemLabel, EstadosItemLabel};
